import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { HeadLine } from '../../layouts/headers/HeadLine';
import RoomCardList from './components/RoomCardList';
import { getApiUrl } from '../../app-config';
import { useRequest } from '../../hooks/useRequest';
import withScrollHandler from '../../hoc/withScrollHandler';
import './Style.css';

const RoomsMainPage = ({ bgimage, scrollpos, handleScroll }) => {

    const appdata = useSelector((store: any) => (store.app));

    const { data } = useRequest(getApiUrl(`Room?hotelId=${appdata.id}&languageKey=es`));

    const [rooms, setRooms] = useState([]);


    useEffect(() => {
        if (data) setRooms(data);
    }, [data])

    return (
        <>
            <div className='w-full absolute z-1 head-hi-sm flex flex-col justify-center'>
                <HeadLine title='Habitaciones' backurl='/' />
            </div>

            <div className="w-full relative content-hi-sm">
                <div className="bg_room_page flex justify-center items-center" style={bgimage}>
                    <img src="/assets/img/icons/room-icon.svg" alt="Icono room" />
                </div>
            </div>

            <div className="absolute z-1 w-full border shadow detail-process-room-container pb-4 bg_page_top" onScroll={handleScroll}
                style={{ height: `calc(100% - ${scrollpos}px)` }}>

                <RoomCardList items={rooms} />
            </div>
        </>
    );
};

export default withScrollHandler(RoomsMainPage, { scrollinit: 258, namebg: 'svg/rooms_bg.svg' });